import {
  arrayBuilderItemSubsequentPageTitleUI,
  yesNoUI,
} from 'platform/forms-system/src/js/web-component-patterns';

import { vaTreatmentFacilityItemSchema } from '../../../schema';

const { treatmentLocation0781Related } =
  vaTreatmentFacilityItemSchema.properties;

export default {
  uiSchema: {
    ...arrayBuilderItemSubsequentPageTitleUI(
      ({ formData }) => formData?.treatmentCenterName,
      undefined,
      false,
    ),
    treatmentLocation0781Related: yesNoUI({
      title:
        'Were you treated for the impact of any traumatic events at this facility?',
      errorMessages: {
        required:
          'Select yes if you were treated for the impact of traumatic events',
      },
    }),
  },
  schema: {
    type: 'object',
    required: ['treatmentLocation0781Related'],
    properties: {
      treatmentLocation0781Related,
    },
  },
};
